import { Icon, TokenInput, WalletGatedButton, Link } from "@/components";
import { useRedeemFormAlt } from "@/hooks";
import { TOKEN_IDS } from "@/types";
import { DialogAwareButtonContainer, DialogAwareContentContainer } from "@/components";
import { getTimeRemaining } from "@/utils";
interface RedeemFormAltProps {
    isLoading?: boolean;
    initialAmount?: number; // This should change depending on if a partial redemption is available or not
    ableToSatisfy?: number;
    isDialog?: boolean;
}
//TODO: NEED proper estimates of time to satify a redemption to include in copy

export function RedeemFormAlt({ isLoading, initialAmount, ableToSatisfy = 0, isDialog }: RedeemFormAltProps) {
    const {
        redeemAmount,
        redeemAmountError,
        selectedTokenId,
        submitRedeemAlt,
        selectTokenId: setRedeemTokenId,
        setMaxAmount,
        simulatedExit,
        loadingSim,
        isAmountOverBalance,
    } = useRedeemFormAlt({
        initialAmount,
    });

    const AMM_LIST = [
        {
            name: "Exit via Fluid (siUSD required)",
            destination: "https://fluid.io/swap/1",
        },
        {
            name: "Exit via Curve",
            destination: "https://www.curve.finance/dex/ethereum/pools/factory-stable-ng-465/deposit/",
        },
        {
            name: "Exit via Balancer",
            destination: "https://balancer.fi/pools/ethereum/v3/0x071828ACC755314E687448703775F22194f56867",
        },
    ];

    const handleSubmit = submitRedeemAlt;
    const handleTokenSelect = setRedeemTokenId;
    const handleMaxClick = setMaxAmount;
    const partialRedeemAvailable = ableToSatisfy > 0;

    return (
        <form onSubmit={handleSubmit}>
            <DialogAwareContentContainer isDialog={isDialog}>
                <div className="flex justify-between items-center rounded-lg gap-4">
                    <div className=" text-md">
                        Due to high demand for redemptions, we are currently unable to
                        {partialRedeemAvailable ? " fully " : " immediately "}
                        satisfy your request for redemption.
                        <p />
                        {partialRedeemAvailable
                            ? ` A partial redemption of ${ableToSatisfy} USDC is available immediately.`
                            : ""}
                        <p />
                        If you wish to continue with your{" "}
                        {partialRedeemAvailable
                            ? "full redemption, any capital not paid out immediately will be available "
                            : "redemption, your redemption request will be enqueued and processed "}
                        {loadingSim && "shortly (estimating...)."}
                        {simulatedExit &&
                            `in ${getTimeRemaining(
                                new Date(simulatedExit.data.fullyFundedTimestampMs).toISOString(),
                                true,
                            )}.`}
                        <p />
                        {partialRedeemAvailable
                            ? "The part of your redemption not paid immediately will be claimable in this queue once fulfilled."
                            : "Your redemption will be claimable in this queue once fulfilled"}
                    </div>
                </div>
                <div className="items-left rounded-lg">
                    <div className="text-lg font-medium">Options for immediate redemption</div>
                    <div className="text-md">
                        Alternatively, you may instead immediately exit your position by swapping it on any one of the
                        listed DEXs:
                    </div>
                    <div className="space-y-0 my-4">
                        {AMM_LIST.map((provider, index) => (
                            <Link
                                key={index}
                                href={provider.destination}
                                target="_blank"
                                rel="noreferrer"
                                className="block"
                            >
                                <div className="px-2 flex items-center justify-between py-3  border-gray-200 border-b hover:bg-primary/20 transition-colors cursor-pointer">
                                    <span className="text-md text-dark">{provider.name}</span>
                                    <div className="flex items-center gap-3">
                                        <Icon name="ArrowTopRightOnSquare" className="w-5 h-5 text-primary" />
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
                <div className="mt-2 font-medium text-lg">Join Redemption Queue</div>
                <TokenInput
                    amount={redeemAmount}
                    amountError={redeemAmountError}
                    selectedTokenId={selectedTokenId}
                    handleTokenSelect={handleTokenSelect}
                    handleMaxClick={handleMaxClick}
                    tokenOptions={[TOKEN_IDS.IUSD]}
                    label="Enter amount to redeem"
                />
            </DialogAwareContentContainer>

            <DialogAwareButtonContainer isDialog={isDialog}>
                <WalletGatedButton
                    className="py-2.5 text-lg"
                    type="submit"
                    isLoading={isLoading}
                    disabled={isAmountOverBalance}
                    fullWidth
                    variant="primary"
                    color="primary"
                >
                    Redeem
                </WalletGatedButton>
            </DialogAwareButtonContainer>
        </form>
    );
}
